import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import styles from './Foto.module.css';
import { getDateMDYY, getDateMDYYYY } from '_helpers'
import { StatusGood, StatusWarning, StatusCritical, FotoButton, LinkButton, RadioButton, LoadingIcon, CommonButton } from '_components';
import { patientActions } from '_actions';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class PatientHomeAdmissionFoto extends React.Component {

    getStatusIndicator(status) {
        switch (status) {
            case 1:
                return (<StatusGood size='extra-small' />);
            case 2:
                return (<StatusWarning size='extra-small' />);
            case 3:
                return (<StatusCritical size='extra-small' />);
            default:
                return (<span />);
        }
    }

    getSeverityTxt(severity) {
        if (severity <= 38) {
            return 'Very Severe';
        } else if (severity > 38 && severity <= 47) {
            return 'Severe';
        } else if (severity > 47 && severity <= 57) {
            return 'Moderate';
        } else if (severity > 57) {
            return 'Slight';
        }
    }

    openFoto() {
        this.props.openPdf(this.props.fotoPdf);
    }

    refreshFotoEpisodes() {
        this.props.refreshFotoEpisodes( this.props.epno, null);
        this.props.loadFotoEpisodes( this.props.ptno);
    }

    toggleFoto() {
        this.props.toggleFoto({ epno: this.props.epno });
    }

    radioClicked(fotoEpisodeId, selected) {
        if (selected) {
            // if selected then release episode
            this.props.changeStatus(this.props.epno, fotoEpisodeId, undefined);
        } else if (!selected && this.props.selectedEpisode) {
            // if !selected and selectedEpisode is not undefined, release and claim
            this.props.changeStatus(this.props.epno, this.props.selectedEpisode, fotoEpisodeId);
        } else if (!selected && !this.props.selectedEpisode) {
            // if !selected and selectedEpisode is undefined, then claim
            this.props.changeStatus(this.props.epno, undefined, fotoEpisodeId);
        }
    }

    render() {
        let firstFoto = this.props.fotos.length > 0 ? this.props.fotos[Object.keys(this.props.fotos)[0]] : undefined;
        return (
            <div>

                <div className={styles.foto_header}>                    
                    {firstFoto &&
                        <span>
                            {'FOTO (' + firstFoto.score + '/' + firstFoto.goal + ')'}
                        </span>
                    }
                    {!firstFoto &&
                        <span>FOTO             </span> 
                    }
                    {firstFoto &&
                        <FotoButton className={styles.foto_button} size='smaller' onClick={() => this.openFoto()} />
                    }
                    {this.props.fotoEpisodes.length === 0 &&
                        <span className={styles.no_foto}>
                            <i>No FOTO Episodes exist</i>
                        </span>
                    }
                    {this.props.fotoEpisodes.length > 0 &&
                        <LinkButton className={styles.link_button} size='smaller' title='Manage FOTO Episodes' onClick={() => this.toggleFoto()} />
                        
                    }
                    {this.props.fotoEpisodes.length > 0 &&
                        <span>       </span>
                    }

                    
                    <CommonButton className={styles.refresh_button} size='smaller' title='Refresh FOTO Information' onClick={() => this.props.fotoRefresh ? null : this.refreshFotoEpisodes()} ><FontAwesomeIcon icon={faRefresh} color="white" className={this.props.fotoRefresh ? styles.spinny : '' }></FontAwesomeIcon></CommonButton>
                </div>
                {this.props.fotoVisible &&
                    <span>
                        {this.props.fotoLoading &&
                            <div className={styles.foto_contact}><LoadingIcon size='small' />&nbsp;&nbsp;Contacting FOTO...</div>
                        }
                        {!this.props.fotoLoading &&
                            <div className={styles.foto_panel}>
                                {Object.keys(this.props.fotoEpisodes)
                                    .map(x => {
                                        const episode = this.props.fotoEpisodes[x];
                                        return (
                                            <div key={episode.fotoEpisodeId} className={styles.foto_entry}>
                                                <RadioButton selected={episode.EPNO === this.props.epno} label={getDateMDYYYY(episode.createDate) + ' - ' + episode.bodyPart} onClick={() => this.radioClicked(episode.fotoEpisodeId, episode.EPNO === this.props.epno)} />
                                            </div>
                                        )
                                    })

                                }
                            </div>

                        }
                    </span>
                }
                {Object.keys(this.props.fotos)
                    .map(id => {
                        const foto = this.props.fotos[id];
                        if (foto.id === firstFoto.id) {
                            return (
                                <div className={styles.foto_wrapper} key={foto.id}>
                                    <span className={styles.indicator}>{this.getStatusIndicator(foto.status)}</span>
                                    <span className={styles.date_range}>{getDateMDYY(foto.date)}</span>
                                    <span className={styles.foto}>{foto.score + ' - ' + this.getSeverityTxt(foto.score)}</span>
                                    <span className={styles.remaining}>{'(' + foto.visitsSinceSurvey + ' visits since survey)'}</span>
                                </div>
                            )
                        } else {
                            return (
                                <div className={styles.foto_wrapper} key={foto.id}>
                                    <span className={styles.indicator}></span>
                                    <span className={styles.date_range}>{getDateMDYY(foto.date)}</span>
                                    <span className={styles.foto}>{foto.score + ' - ' + this.getSeverityTxt(foto.score)}</span>
                                    <span className={styles.remaining}></span>
                                </div>
                            )
                        }
                    })
                }
                {!firstFoto &&
                    <div className={styles.no_foto}>
                        <i>No FOTO Surveys</i>
                    </div>
                }
            </div>
        );
        
    }
}

function mapDispatchToProps(dispatch) {
    return {
        openPdf: bindActionCreators(patientActions.openPdf, dispatch),
        toggleFoto: bindActionCreators(patientActions.toggleFotoPanelVisibility, dispatch),
        refreshFotoEpisodes: bindActionCreators(patientActions.refreshFotoEpisodes, dispatch),
        changeStatus: bindActionCreators(patientActions.changeFotoClaimStatus, dispatch),
        loadFotoEpisodes: bindActionCreators(patientActions.loadFotoEpisodes, dispatch)
    };
}


function mapStateToProps(state, ownprops) {
    let fotoTypes = [13, 14, 15, 16, 17, 18, 19, 20, 21];
    let fotoPdf = undefined;
    let fotoPdfs = Object.keys(state.entities.cdv)
        .filter(x => state.entities.cdv[x].epno === ownprops.epno && fotoTypes.includes(state.entities.cdv[x].noteType))
        .sort((a, b) => new Date(state.entities.cdv[b].dos).getTime() - new Date(state.entities.cdv[a].dos).getTime());
    let fotoVisible = state.ui.admissions[ownprops.epno].fotoPanelVisible;
    let fotoLoading = state.ui.admissions[ownprops.epno].fotoPanelLoading;
    let fotoRefresh = state.ui.admissions[ownprops.epno].fotoRefreshing;
    let ptno = state.ui.admissions[ownprops.epno].ptno;

    let fotoEpisodes = Object.keys(state.entities.fotoEpisodes)
        .filter(x => state.entities.fotoEpisodes[x].EPNO === ownprops.epno || (state.entities.fotoEpisodes[x].EPNO === null && state.entities.fotoEpisodes[x].PTNO === ptno))
        .sort((a, b) => state.entities.fotoEpisodes[a].createDate - state.entities.fotoEpisodes[b].createDate)
        .map(x => state.entities.fotoEpisodes[x]);

    let selectedEpisode = Object.keys(state.entities.fotoEpisodes)
        .find(x => state.entities.fotoEpisodes[x].EPNO === ownprops.epno);

    if (fotoPdfs.length > 0) {
        fotoPdf = fotoPdfs[0];
    }

    return {
        fotoPdf,
        fotoVisible,
        fotoLoading,
        fotoEpisodes,
        selectedEpisode,
        fotoRefresh,
        ptno,
        fotos: Object.keys(state.entities.fotoSurveys)
            .filter(key => { return state.entities.fotoSurveys[key].epno === ownprops.epno })
            .sort((a, b) => new Date(state.entities.fotoSurveys[b].date).getTime() - new Date(state.entities.fotoSurveys[a].date).getTime())
            .map(key => state.entities.fotoSurveys[key]),
    };
}

const connectedPatientHomeAdmissionFoto = connect(mapStateToProps, mapDispatchToProps)(PatientHomeAdmissionFoto);
export { connectedPatientHomeAdmissionFoto as PatientHomeAdmissionFoto };

